import { Stack, Text, Title } from "@mantine/core";
import { FormattedMessage, useIntl } from "react-intl";
import { AppWebviewLayout } from "../AppWebviewLayout";
import { ActionCarousel, type ActionCard } from "./ActionCarousel";
import highFiveUrl from "../../../assets/highfive-yellow.svg?url";
import shared from "../appWebviewShared.module.css";

export function DataCollectionScreen({ cards }: { cards: ActionCard[] }) {
  const intl = useIntl();

  return (
    <AppWebviewLayout>
      <Stack gap="xl">
        <Stack gap="sm" align="center">
          <img src={highFiveUrl} alt="" className={shared.doorIcon} />
          <Title
            order={1}
            fz="h2"
            ff="var(--wallet-font-family-sambla-sans)"
            ta="center"
          >
            <FormattedMessage
              id="app.poaOnb.waiting.headline"
              defaultMessage="Vi är igång!"
            />
          </Title>
          <Text
            c="var(--wallet-color-neutrals-gray-600)"
            size="md"
            lh={1.6}
            ta="center"
          >
            <FormattedMessage
              id="app.poaOnb.waitingScreen.description"
              defaultMessage="Vi hämtar din pensionsdata och fyller på översikten steg för steg. Din allmänna pension visas inom <b>24 timmar</b>, medan andra uppgifter kan ta upp till några dagar att hämta."
            />
          </Text>
        </Stack>
        <ActionCarousel
          heading={intl.formatMessage({
            id: "app.poaOnb.waiting.meanwhile.headline",
            defaultMessage: "Det här kan du göra så länge",
          })}
          cards={cards}
        />
      </Stack>
    </AppWebviewLayout>
  );
}
